import { fetchRegionsMock, fetchStateReferenceMock, updateStateReferenceMock } from './parameters.mock';
import type { RegionDTO, StateReferenceDTO } from '../types/parameters.types';

export const parametersService = {
	fetchRegions: (): Promise<RegionDTO[]> => fetchRegionsMock(),

	fetchStateReference: (stateReferenceId: string): Promise<StateReferenceDTO> =>
		fetchStateReferenceMock(stateReferenceId),

	updateStateReference: (id: string, data: StateReferenceDTO): Promise<StateReferenceDTO> =>
		updateStateReferenceMock(id, data),
};
